import { TWISTERS } from "../content/twisters";
import { gradeCard } from "../engine/srs";
import { touchDay } from "../engine/streak";
import { sweepPlaques } from "../engine/plaques";
import { addDays } from "../lib/date";
import { defaultProfile, type Profile } from "../state/profile";

/** A hand-seeded ~47-day profile, for visually checking screens without
    grinding out real usage. Loaded when the URL has ?seed=demo. */
export function buildDemoProfile(): Profile {
  let p: Profile = defaultProfile(777);
  p.identity = { goal: "meetings", langs: ["en", "sv"], primaryLang: "en", when: "morning" };
  p.seen.onboarded = true;

  const start = addDays(new Date().toISOString().slice(0, 10), -46);
  const sample = TWISTERS.filter((t) => t.lang === "en").slice(0, 12);

  for (let i = 0; i < 47; i++) {
    const day = addDays(start, i);
    if (i % 6 === 5) continue; // a missed day here and there — realistic, not perfect

    const twister = sample[i % sample.length]!;
    const existing = p.cards[twister.id];
    p.cards[twister.id] = gradeCard(existing ?? { id: twister.id, due: 0, interval: 0, ease: 2.3, reps: 0, lapses: 0, lastGrade: 2 }, i % 5 === 0 ? 1 : 2, day);

    for (const ph of twister.phonemes) {
      const prog = p.phonemes[ph] ?? { xp: 0, attempts: 0, clean: 0 };
      p.phonemes[ph] = { xp: prog.xp + 5, attempts: prog.attempts + 1, clean: prog.clean + (i % 4 === 0 ? 0 : 1) };
    }

    p.clarity += 60 + (i % 3) * 15;
    p.seconds += 280;
    p.sessions += 1;
    p.bests.phonationSec = Math.max(p.bests.phonationSec, 12 + (i % 10));
    p.bests.plosiveAccuracy = Math.max(p.bests.plosiveAccuracy, 70 + (i % 20));

    const touched = touchDay(p, day, { closesRing: i % 7 !== 6, lang: i % 3 === 0 ? "sv" : "en" });
    p = touched.profile;
    p = sweepPlaques(p, day).profile;
  }

  return p;
}
